import "core-js/modules/es.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import BasePop from '../Pop/BasePop/BasePop.vue';
export default {
  components: {
    Avatar: Avatar,
    BasePop: BasePop
  },
  data: function data() {
    return {
      player: null,
      isShowClose: false,
      isPlaying: false,
      isPlayerError: false,
      showRule: false,
      isPlayerPassiveStop: false
    };
  },
  computed: {
    // 当前播放的视频信息
    videoInfo: function videoInfo() {
      return this.setting.时间线[this.currentIndex] || this.setting.时间线[0];
    },
    // 当前点亮的索引
    currentIndex: function currentIndex() {
      var _this = this;

      var index = this.setting.时间线.findIndex(function (item) {
        return item.开始时间 <= _this.now && item.结束时间 >= _this.now;
      }); // 只有第三个才需要偏移一下

      if (index === 2) {
        this.$nextTick(function () {
          var el = _this.$el.querySelector('.progress');

          el.scrollTo({
            left: 350
          });
        });
      }

      return index === -1 ? 0 : index;
    }
  },
  methods: {
    closeVideo: function closeVideo() {
      this.isShowClose = false;
      this.eventBus.$emit('stopVideo', false);
    },
    // 点播
    playDemandVideo: function playDemandVideo() {
      var _this2 = this;

      // 点播vid
      var vid = this.videoInfo.vid;

      if (this.player) {
        this.player.play(vid);
        return;
      } // 播放器尺寸


      var config = {
        containerId: 'video_wrap',
        vid: vid,
        width: '100%',
        height: '100%',
        playerType: 'h5',
        autoplay: true // muted: true,

      };
      var vm = this;
      vm.player = new window.Txplayer(config);
      vm.player.on('ready', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (vm.player.play) {
                  _context.next = 3;
                  break;
                }

                vm.player = null;
                return _context.abrupt("return");

              case 3:
                vm.player.play();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))); // 监听播放开始或者结束

      vm.player.on('playStateChange', function (state) {
        _this2.isPlaying = state === 1;

        if (_this2.isPlaying) {
          _this2.isShowClose = true;
        } // 已结束


        if (state === 0) {
          _this2.isShowClose = false;
        }
      }); // 监听广告开始，显示video

      vm.player.on('adStart', function () {
        _this2.isPlaying = true;
        _this2.isShowClose = true;
      }); // 播放是否错误

      this.player.on('error', function () {
        _this2.isPlayerError = true;
      });
    },
    bindEvent: function bindEvent() {
      var _this3 = this;

      // 监听视频暂停事件
      this.eventBus.$on('stopVideo', function () {
        var _this3$player;

        var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (_this3.isPlayerError || !_this3.isPlaying) {
          return;
        }

        _this3.isPlayerPassiveStop = flag; // eslint-disable-next-line no-unused-expressions

        (_this3$player = _this3.player) === null || _this3$player === void 0 ? void 0 : _this3$player.pause();
      }); // 监听继续视频播放

      this.eventBus.$on('playVideo', function () {
        var _this3$player2;

        // 非被动终止播放，不用继续播放
        if (!_this3.isPlayerPassiveStop || _this3.isPlayerError) {
          return;
        }

        _this3.isPlayerPassiveStop = false; // eslint-disable-next-line no-unused-expressions

        (_this3$player2 = _this3.player) === null || _this3$player2 === void 0 ? void 0 : _this3$player2.play();
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};